(function($) {
  
    $(window).on('load', function () {
      
        $('footer .menu-item-has-children').each(function(el) {
            function openSubmenu(element) {
                element.find('a[href="#"]').addClass('open')
                
                const submenu = element.find('.menu')
                const submenuHeight = submenu[0].scrollHeight
                
                submenu.height(submenuHeight)
            }
            
            function closeSubmenu(element) {
                element.find('a[href="#"]').removeClass('open')
                element.find('a[href="#"').attr('data-submenu', null)
                
                const submenu = element.find('.menu')
                
                submenu.attr('style', null)
            }
            
            $(this).find('> a').on('click', event => {
                const mainLink = $(this).find('a[href="#"]')
                
                if(mainLink) {
                    event.preventDefault()
                    $(this).find('.menu').css('height') == '0px' 
                        ? openSubmenu($(this)) 
                        : closeSubmenu($(this))
                }
            })
            
            $(this).find('> a').on('mouseenter', () => {
                openSubmenu($(this))
            })
            
            $(this).find('.menu').on('mouseenter', () => {
                openSubmenu($(this))
            })
            
            $(this).find('> a').on('mouseleave', () => {
                closeSubmenu($(this))
            })
            
            $(this).find('.menu').on('mouseleave', () => {
                closeSubmenu($(this))
            })
        })
    
    });

})(jQuery);
(function($) {
    // Menu
    function menuToggle(e) {
        $('.mobile-menu-button').toggleClass('open');
        $('.main-navbar').toggleClass('open');
        $('body').toggleClass('no-scroll');
    }
    $('.mobile-menu-button').on('click', menuToggle);
    
    function submenuToggle(e) {
      e.preventDefault()
      
      if ($(this).attr('href') != "#" && screen.width > 1200) {  
        window.location.replace($(this).attr('href'));
      }
      
      $(this).parent().toggleClass('active');
      
      let submenu = $(this).next('ul');
      
      if ($(this).parent().hasClass('active') && submenu.length) {
        submenu.height( submenu.prop("scrollHeight") );
      } else {
        submenu.height( 0 );
      }
    }
    $('.main-navbar .menu-item-has-children > a').on('click tap', submenuToggle);
    
    function closeMenuOnClick(event) {
      if(!$(event.target).parent().hasClass('menu-item-has-children')) {
        menuToggle();
      }
    }
    $('.main-navbar a').on('click', function(e) {
      if(window.matchMedia('(max-width: 1200px)').matches) {
        closeMenuOnClick(e)
        return
      }
    })
    $('footer a[href="#"]').on('click', function(e) {
      e.preventDefault();
    });
  
})(jQuery);
(function($) {
    
    const clima = document.querySelectorAll('.modulo-clima')
    
    if(clima && window.lojasClima) {
        
        clima.forEach(el => {
            const widgetContainer = el.querySelector('.widget-container')
            const selectLocation = el.querySelector('.select-location')
            
            selectLocation.removeAttribute('disabled')
            
            selectLocation.addEventListener('change', () => {
                const currentLocation = window.lojasClima.find(unidade => unidade.id === selectLocation.value)
                
                if(currentLocation) {
                    const cidade = currentLocation.cidade
                    const estado = currentLocation.estado
                    const url = currentLocation.climaUrl
                    
                    widgetContainer.innerHTML = `
                        <a 
                            class="weatherwidget-io"
                            href="${url}"
                            data-label_1="${cidade}"
                            data-label_2="${estado}"
                            data-font="Helvetica"
                            data-icons="Climacons Animated"
                            data-theme="gray"
                            data-basecolor="#017431"
                            data-highcolor=""
                            data-lowcolor="#0ebbfd"
                            data-suncolor="#ffc800"
                            data-cloudfill="rgba(255, 255, 255, 0.6)"
                        >
                            ${cidade} - ${estado}
                        </a>
                    `
                    
                    __weatherwidget_init()
                }
            })
        })
    }
    
})(jQuery);
(function($) {
    
    const rawData = window.jsonData ? window.jsonData : null
    
    if(rawData) {
        const pinIcon = rawData.pinIcon ? rawData.pinIcon : null
        const arrowIcon = rawData.arrowIcon ? rawData.arrowIcon : null
        const phoneIcon = rawData.phoneIcon ? rawData.phoneIcon : null
        const whatsappIcon = rawData.whatsappIcon ? rawData.whatsappIcon : null
        const defaultImage = rawData.defaultImage ? rawData.defaultImage : null
        const data = rawData.unidades ? JSON.parse(rawData.unidades) : null
        
        class InteractiveMap {
            constructor(container = null, data = null) {
                this.container = container
                this.data = data
                
                if(!container) {
                    console.error('No element selected')
                    return false
                }
                
                if(!data) {
                    console.error('No data provided')
                    return false
                }
                
                this.options = this.container.querySelectorAll('.button-container button')
                this.select = this.container.querySelector('.options-select')
                
                this.currentOption = this.container.querySelector('.button-container button.active').dataset.target
                this.currentData = this.data.find(el => el.id === this.currentOption)
                
                this.textContainer = this.container.querySelector('.content-box .text-container')
                this.mapContainer = this.container.querySelector('.interactive-map')
                this.map = null
                this.defaultXCoordinate = null
                this.defaultYCoordinate = null
                this.defaultMapZoom = 8
                this.dynamicImageContainer = this.container.querySelector('.dynamic-image')
                
                this._init()
            }
            
            _init() {
                this.options.forEach(option => {
                    option.addEventListener('click', event => {
                        this._getCurrentOption(event.target)
                    })
                })
                
                this.select.addEventListener('change', event => {
                    this._getCurrentOption(event.target)
                })
                
                this._initializeMap()
                this._updateMapPosition()
            }
            
            _getCurrentOption(el) {
                let target = null
                
                if(el.tagName === 'SELECT') {
                    target = el.value
                } else {
                    target = el.dataset.target
                }
                
                if(target === this.currentOption) {
                    this._updateMapPosition()
                    return
                }
                
                this.currentOption = target
                this.currentData = this.data.find(el => el.id === target)
                
                this.options.forEach(el => {
                    if(el.dataset.target === this.currentOption) {
                        el.classList.add('active')
                        return
                    }
                    
                    el.classList.remove('active')
                })
                
                this.select.value = this.currentOption
                
                this._updateTextData()
                
                if(this.map) {
                    this._updateMapPosition()
                }
                
                if(this.dynamicImageContainer) {
                    this._updateImage()
                }
            }
            
            _updateTextData() {
                const title = document.createElement('p')
                title.classList.add('title')
                title.textContent = this.currentData.nome ? this.currentData.nome : `${this.currentData.tipo} ${this.currentData.cidade}`
                
                const small = document.createElement('small')
                small.textContent = this.currentData.estado
                
                title.appendChild(small)
                
                let info = null
                let contactButton = null
                
                if(this.currentData.endereco || this.currentData.telefone || this.currentData.whatsapp) {
                    info = document.createElement('ul')
                    info.classList.add('info')
                    
                    if(this.currentData.endereco) {
                        const address = document.createElement('li')
                        
                        if(this.currentData.maps) {
                            const link = document.createElement('a')
                            link.href = this.currentData.maps
                            link.target = '_blank'
                            link.innerHTML = this.currentData.nome 
                                ? pinIcon + `${this.currentData.endereco}, ${this.currentData.cidade}` 
                                : pinIcon + this.currentData.endereco
                            
                            address.appendChild(link)
                        } else {
                            const paragraph = document.createElement('p')
                            paragraph.innerHTML = this.currentData.nome 
                                ? pinIcon + `${this.currentData.endereco}, ${this.currentData.cidade}` 
                                : pinIcon + this.currentData.endereco
                            
                            address.appendChild(paragraph) 
                        }
                        
                        info.appendChild(address)
                    }
                    
                    if(this.currentData.whatsapp) {
                        const contact = document.createElement('li')
                        
                        const link = document.createElement('a')
                        link.href = `https://wa.me/55${this.currentData.whatsapp.replace(/\D/g, '')}`
                        link.target = '_blank'
                        link.innerHTML = whatsappIcon + this.currentData.whatsapp
                        
                        contact.appendChild(link)
                        info.appendChild(contact)
                        
                        contactButton = document.createElement('div')
                        contactButton.classList.add('contact-button-container')
                        
                        const button = document.createElement('a')
                        button.classList.add('button')
                        button.href = `https://wa.me/55${this.currentData.whatsapp.replace(/\D/g, '')}`
                        button.target = '_blank'
                        button.innerHTML = arrowIcon + 'Entrar em contato'
                        
                        contactButton.appendChild(button)
                        
                    } else if(this.currentData.telefone) {
                        const contact = document.createElement('li')
                        
                        const link = document.createElement('a')
                        link.href = `tel:55${this.currentData.telefone.replace(/\D/g, '')}`
                        link.innerHTML = phoneIcon + this.currentData.telefone
                        
                        contact.appendChild(link)
                        info.appendChild(contact)
                        
                        contactButton = document.createElement('div')
                        contactButton.classList.add('contact-button-container')
                        
                        const button = document.createElement('a')
                        button.classList.add('button')
                        button.href = `tel:55${this.currentData.telefone.replace(/\D/g, '')}`
                        button.innerHTML = arrowIcon + 'Entrar em contato'
                        
                        contactButton.appendChild(button)
                    }
                }
                
                this.textContainer.innerHTML = null
                this.textContainer.appendChild(title)
                this.textContainer.appendChild(info)
                this.textContainer.appendChild(contactButton)
            }
            
            _updateImage() {
                let imageData = this.currentData.imagem && this.currentData.imagem.url 
                    ? this.currentData.imagem 
                    : defaultImage
                    
                if(this.dynamicImageContainer.querySelector('img').getAttribute('src') === imageData.url) return
                
                let imageElement = document.createElement('img')
                imageElement.src = imageData.url
                imageElement.width = imageData.width
                imageElement.height = imageData.height
                imageElement.alt = ''
                
                this.dynamicImageContainer.innerHTML = null
                this.dynamicImageContainer.appendChild(imageElement)
            }
            
            _initializeMap() {
                if(this.mapContainer) {
                    const features = []
                    
                    let xCoordinates = []
                    let yCoordinates = []
                    
                    for(let pin of this.data) {
                        if(pin.eixo_x && pin.eixo_y) {
                            const feature = new ol.Feature({
                                name: `${pin.cidade} - ${pin.estado}`,
                                geometry: new ol.geom.Point(ol.proj.fromLonLat([pin.eixo_y, pin.eixo_x]))
                            })
                            
                            xCoordinates.push(pin.eixo_x)
                            yCoordinates.push(pin.eixo_y)
                            features.push(feature)
                        }
                    }
                    
                    let maxX = Math.max(...xCoordinates)
                    let minX = Math.min(...xCoordinates)
                    let maxY = Math.max(...yCoordinates)
                    let minY = Math.min(...yCoordinates)
                    
                    const averageX = (maxX + minX) / 2
                    const averageY = (maxY + minY) / 2
                    
                    this.defaultXCoordinate = averageX
                    this.defaultYCoordinate = averageY
                    
                    this.map = new ol.Map({
                        target: this.mapContainer,
                        controls: ol.control.defaults({ attribution: false }),
                        interactions: ol.interaction.defaults({mouseWheelZoom: false}),
                        layers: [
                            new ol.layer.Tile({
                                title: 'Toni Cerealista',
                                className: 'bw',
                                source: new ol.source.OSM()
                            }),
                            new ol.layer.Vector({
                                source: new ol.source.Vector({
                                    className: 'icon',
                                    features: features
                                }),
                                style: new ol.style.Style({
                                    image: new ol.style.Icon({
                                        anchor: [0.5, 1],
                                        anchorXUnits: 'fraction',
                                        anchorYUnits: 'fraction',
                                        scale: 1,
                                        src: this.mapContainer.dataset.markers
                                    })
                                })
                            }),
                        ],
                        view: new ol.View({
                            center: ol.proj.fromLonLat([averageY, averageX]),
                            zoom: this.defaultMapZoom
                        })
                    })
                }
            }
            
            _updateMapPosition() {
                const xCoordinate = this.currentData.eixo_x ? this.currentData.eixo_x : this.defaultXCoordinate
                const yCoordinate = this.currentData.eixo_y ? this.currentData.eixo_y : this.defaultYCoordinate
                
                const center = ol.proj.fromLonLat([yCoordinate, xCoordinate]);
                
                this.map.getView().animate({
                    center: center,
                    duration: 1000,
                    zoom: this.currentData.eixo_x && this.currentData.eixo_y ? 15 : this.defaultMapZoom
                });
            }
        }
        
        const map = document.querySelector('.modulo-mapa-interativo')
        
        if(map) new InteractiveMap(map, data)
    }
    
})(jQuery);
(function($) {
    
    // Mapa
    const mapa = document.querySelectorAll('.modulo-mapa')
    
    if(mapa && window.lojasMapa) {
        mapa.forEach(el => {
            const features = []
            
            let xCoordinates = []
            let yCoordinates = []
            
            for(let pin of window.lojasMapa) {
                const feature = new ol.Feature({
                    name: `${pin.cidade} - ${pin.estado}`,
                    geometry: new ol.geom.Point(ol.proj.fromLonLat([pin.eixo_y, pin.eixo_x]))
                })
                
                xCoordinates.push(pin.eixo_x)
                yCoordinates.push(pin.eixo_y)
                features.push(feature)
            }
            
            let maxX = Math.max(...xCoordinates)
            let minX = Math.min(...xCoordinates)
            let maxY = Math.max(...yCoordinates)
            let minY = Math.min(...yCoordinates)
            
            const averageX = (maxX + minX) / 2
            const averageY = (maxY + minY) / 2
            
            new ol.Map({
                target: el,
                controls: ol.control.defaults({ attribution: false }),
                interactions: ol.interaction.defaults({mouseWheelZoom: false}),
                layers: [
                    new ol.layer.Tile({
                        title: 'Toni Cerealista',
                        className: 'bw',
                        source: new ol.source.OSM()
                    }),
                    new ol.layer.Vector({
                        source: new ol.source.Vector({
                            className: 'icon',
                            features: features
                        }),
                        style: new ol.style.Style({
                            image: new ol.style.Icon({
                                anchor: [0.5, 1],
                                anchorXUnits: 'fraction',
                                anchorYUnits: 'fraction',
                                scale: 1,
                                src: el.dataset.markers
                            })
                        })
                    }),
                ],
                view: new ol.View({
                    center: ol.proj.fromLonLat([averageY, averageX]),
                    zoom: 8
                })
            });
        })
    }
    
})(jQuery);
(function($) {
    
    // CF7 events
	const cf7 = document.querySelectorAll('.wpcf7 form')
	
	if(cf7) {
		cf7.forEach(form => {
			form.addEventListener('submit', function() {
				this.querySelector('button[type=submit]').setAttribute('disabled', true)
			})
		
			form.addEventListener('wpcf7submit', function() {
				this.querySelector('button[type=submit]').removeAttribute('disabled')
			})
		})
	}
	
    // Mask phone input
    let phoneMaskFunction = function(val) {
    	return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    }
    
    $('input[type="tel"]').mask(phoneMaskFunction, {
    	onKeyPress: function(val, e, field, options) {
    		field.mask(phoneMaskFunction.apply({}, arguments), options);
    	}
    });
    
})(jQuery);

(function($) {
	
	const produtos = $('.produtos .slider-container')
	
	if (produtos.length) {
			
		produtos.each(function() {
			const container = $(this)
			const slider = container.find('.slider-wrapper')
			const prevArrow = container.find('.prev')
			const nextArrow = container.find('.next')
			
			slider.slick({
				accessibility: false,
				slidesToShow: 3,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							dots: false,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
							appendDots: container
						}
					}
				]
			})
		})
	}

})(jQuery);
(function($) {
    
    const mainContainer = $('.anos-de-historia .container')
    
    if(mainContainer.length) {
        const sharedSettings = {
            accessibility: false,
			draggable: false,
			fade: true,
			speed: 500,
			infinite: false,
			dots: false,
			arrows: false,
        }
        
        mainContainer.find('.image-slider-container').slick({
			...sharedSettings,
			asNavFor: mainContainer.find('.text-slider-container')
        })
        
        mainContainer.find('.text-slider-container').slick({
			...sharedSettings,
			arrows: true,
			prevArrow: mainContainer.find('.prev'),
			nextArrow: mainContainer.find('.next'),
			asNavFor: mainContainer.find('.image-slider-container')
        })
    }
    
})(jQuery);
(function($) {
    
    const marcas = $('.template-nossos-produtos .marcas .slider-container')
    
    if(marcas.length) {
        
        marcas.each(function() {
			const container = $(this)
			const slider = container.find('.slider-wrapper')
			const prevArrow = container.find('.prev')
			const nextArrow = container.find('.next')
			
			slider.slick({
				accessibility: false,
				slidesToShow: 5,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				autoplay: 100,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [
					{
						breakpoint: 992,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1,
							dots: false,
						}
					},
					{
						breakpoint: 576,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
							arrows: false,
							dots: true,
							appendDots: container
						}
					}
				]
			})
		})
    }
    
})(jQuery);
(function($) {
    
    const produtos = $('.template-nossos-produtos .produtos-container .produto .slider-container')
    
    if(produtos.length) {
        
        produtos.each(function() {
			const container = $(this)
			const slider = container.find('.slider-wrapper')
			const prevArrow = container.find('.prev')
			const nextArrow = container.find('.next')
			
			slider.slick({
				accessibility: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				dots: false,
				arrows: true,
				prevArrow: prevArrow,
				nextArrow: nextArrow,
				responsive: [
					{
						breakpoint: 576,
						settings: {
							arrows: false,
							dots: true,
							appendDots: container
						}
					}
				]
			})
		})
    }
    
})(jQuery);